module.exports = __webpack_public_path__ + "img/9791187373797.21c9a77b.jpg";